// src/pages/AvisosPage.js

import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { FaBullhorn, FaUsers, FaPlus } from 'react-icons/fa';
import { db } from '../firebase';
import { collection, getDocs, query, where } from 'firebase/firestore';
import { useAuth } from '../context/AuthContext';
import './AvisosPage.css';

const AvisosPage = () => {
    const { userData } = useAuth();
    const fraccionamientoId = userData?.fraccionamientoId || userData?.fraccionamientoTd || null;
    const navigate = useNavigate();

    const [counts, setCounts] = useState({
        'Anuncios Generales': 0,
        'Avisos Importantes': 0,
        'Votaciones Activas': 0,
    });
    const role = userData?.rol?.toLowerCase();
    const esAdmin = role === 'superadmin' || role === 'platformadmin' || role === 'admin' || role === 'admin_fracc';

    useEffect(() => {
        if (!fraccionamientoId) return;

        const fetchCounts = async () => {
            try {
                const comunicadosRef = collection(db, 'fraccionamientos', fraccionamientoId, 'comunicados');

                // Only fetch votaciones if the user is an admin
                let votacionesSnapshot = { size: 0 };

                if (esAdmin) {
                    const votacionesRef = collection(db, 'fraccionamientos', fraccionamientoId, 'votaciones');
                    const votacionesActivasQuery = query(votacionesRef, where("estado", "==", "activa"));
                    votacionesSnapshot = await getDocs(votacionesActivasQuery);
                }

                const comunicadosSnapshot = await getDocs(comunicadosRef);

                const newComunicadosCounts = { 'Anuncios Generales': 0, 'Avisos Importantes': 0 };
                comunicadosSnapshot.forEach((doc) => {
                    const categoria = doc.data().categoria;
                    if (categoria in newComunicadosCounts) newComunicadosCounts[categoria]++;
                });

                setCounts({
                    ...newComunicadosCounts,
                    'Votaciones Activas': votacionesSnapshot.size,
                });
            } catch (error) {
                console.error('Error al obtener comunicados o votaciones: ', error);
                setCounts({ 'Anuncios Generales': 0, 'Avisos Importantes': 0, 'Votaciones Activas': 0 });
            }
        };

        fetchCounts();
    }, [fraccionamientoId, esAdmin]);

    const comunicados = [
        { nombre: 'Anuncios Generales', count: counts['Anuncios Generales'], link: `/comunidad/comunicados/Anuncios Generales` },
        { nombre: 'Avisos Importantes', count: counts['Avisos Importantes'], link: `/comunidad/comunicados/Avisos Importantes` },
    ];

    const participacion = esAdmin ? [
        { nombre: 'Votaciones Activas', count: counts['Votaciones Activas'], link: '/comunidad/votaciones' },
    ] : [];

    return (
        <div className="avisos-page-wrapper">
            <header className="avisos-header-hero">
                <div className="avisos-header-content">
                    <div className="avisos-header-icon">
                        <FaBullhorn />
                    </div>
                    <div className="avisos-header-text">
                        <h1>Votaciones y Avisos</h1>
                        <p>Gestiona los procesos de participación y mantén informada a la comunidad con comunicados oficiales.</p>
                    </div>
                </div>
            </header>

            <div className="avisos-page-container">
                {/* Tarjeta de Comunicados */}
                <div className="aviso-card">
                    <div className="aviso-header-premium">
                        <div className="aviso-icon-wrapper">
                            <FaBullhorn />
                        </div>
                        <div className="aviso-header-text">
                            <h3>Comunicados</h3>
                            <p>Anuncios y avisos importantes para la comunidad.</p>
                        </div>
                    </div>
                    <ul className="category-list">
                        {comunicados.map(item => (
                            <li key={item.nombre}>
                                <Link to={item.link}>{item.nombre} ({item.count})</Link>
                            </li>
                        ))}
                    </ul>
                    {esAdmin && (
                        <button onClick={() => navigate('/comunidad/comunicados/nuevo')} className="btn-new">
                            <FaPlus /> Nuevo Comunicado
                        </button>
                    )}
                </div>

                {/* Tarjeta de Participación: sólo para administradores */}
                {participacion.length > 0 && (
                    <div className="aviso-card">
                        <div className="aviso-header-premium participation-header">
                            <div className="aviso-icon-wrapper">
                                <FaUsers />
                            </div>
                            <div className="aviso-header-text">
                                <h3>Participación</h3>
                                <p>Decide el futuro de tu comunidad votando aquí.</p>
                            </div>
                        </div>
                        <ul className="category-list">
                            {participacion.map(item => (
                                <li key={item.nombre}>
                                    <Link to={item.link}>{item.nombre} ({item.count})</Link>
                                </li>
                            ))}
                        </ul>
                        {esAdmin && (
                            <button onClick={() => navigate('/comunidad/votaciones/crear')} className="btn-new">
                                <FaPlus /> Nueva Votación
                            </button>
                        )}
                    </div>
                )}
            </div>
        </div>
    );
};

export default AvisosPage;